"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOpHitTestComponent = void 0;
/**
 * @public
 * A hit test component that will never hit.
 */
class NoOpHitTestComponent {
    hitTest() {
        return false;
    }
    index() {
        // no action required
    }
}
exports.NoOpHitTestComponent = NoOpHitTestComponent;
//# sourceMappingURL=no-op-hit-test-component.js.map